import { render, staticRenderFns } from "./MyFieldSelectComponent.vue?vue&type=template&id=8b7bcb88"
import script from "./MyFieldSelectComponent.vue?vue&type=script&lang=js"
export * from "./MyFieldSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports